import { Switch } from "@headlessui/react";
import TextArea from "./TextArea";
import Select from "./Select";
import React from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "flowbite-react";

const CreateUpdateIntentModalBody = ({
  intent,
  handleInputChange,
  showTooltips,
}) => {
  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex mt-4 mb-2  text-gray-800 text-sm font-medium leading-tight">
          Name
        </div>
      </div>
      <TextArea
        placeholder="Example: Refund customer"
        rows={2}
        value={intent.type}
        required
        onChange={e => handleInputChange("type", e.target.value)}
      />

      <div className="flex mt-3 mb-2 text-gray-800 text-sm font-medium leading-tight">
        Description *
      </div>
      <TextArea
        placeholder="Example: Customer is inquiring about a refund and wants to know more about the process of how to get one."
        rows={4}
        value={intent.description}
        required
        onChange={e => handleInputChange("description", e.target.value)}
      />

      <div className="flex mt-3 mb-1 text-gray-800 text-sm font-medium leading-tight">
        Category *
      </div>
      <Select
        value={intent.category}
        onChange={e => {
          handleInputChange("category", e.target.value);
        }}
        options={[
          { value: "Order Management", label: "Order Management" },
          { value: "Account Management", label: "Account Management" },
        ]}
      />

      <div className="mt-3 mb-2 text-gray-800 text-sm font-medium leading-tight flex items-center gap-1">
        <span>AI Agent Instructions *</span>
        {showTooltips && (
          <Tooltip
            theme={{
              target: "flex",
            }}
            content={
              <div className="max-w-sm">
                When entering steps, make sure to use periods at the end of each
                step as the AI agent performs better.
              </div>
            }
          >
            <QuestionMarkCircleIcon className="size-5 cursor-pointer" />
          </Tooltip>
        )}
      </div>
      <TextArea
        placeholder="Example:
1. If the customer wants a refund and they don’t provide a reason.
2. Ask them to clarify why they want a refund.
3. Find out if the product was broken or they just didn’t like it. If they didn’t like it, ask them why not.
4. Then ask if they’d prefer a refund back to their payment method or a credit to their account.
5. Transfer the conversation to a human after getting this information."
        rows={10}
        value={intent.response}
        required
        onChange={e => handleInputChange("response", e.target.value)}
      />

      {/*<div className="flex mt-3 mb-1 text-gray-800 text-sm font-semibold leading-tight">
        Collect Email
      </div>
      <div className="flex mb-2  justify-between items-center text-gray-600 leading-tight text-sm">
        <div className="inline-flex items-center pr-3">
          If this is turned on, after this intent is recognized and the response
          is sent, your AI Agent will collect the user’s email if they aren’t
          already authenticated.
        </div>
        <Switch
          checked={intent.email_collect}
          onChange={() =>
            handleInputChange("email_collect", !intent.email_collect)
          }
          className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 data-[checked]:bg-primary"
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
          />
        </Switch>
      </div>

      <div className="flex mt-3 mb-1 text-gray-800 text-sm font-semibold leading-tight">
        Hand Off to Team
      </div>
      <div className="flex mb-2 justify-between items-center text-gray-600 leading-tight text-sm">
        <div className="inline-flex items-center pr-3">
          If this is turned on, after this intent is recognized and the response
          is sent, your AI Agent will hand off this task to your team to execute
          the final work required.
        </div>
        <Switch
          checked={intent.hand_off}
          onChange={() => handleInputChange("hand_off", !intent.hand_off)}
          className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 data-[checked]:bg-primary"
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
          />
        </Switch>
      </div>*/}

      <div className="flex mt-3 mb-1 text-gray-800 text-sm font-semibold leading-tight">
        Set live
      </div>
      <div className="flex mb-2 justify-between items-center text-gray-600 leading-tight text-sm">
        <div className="inline-flex justify-center pr-3">
          You’ll be able to try this out in the Testing section before setting
          it live.
        </div>
        <Switch
          checked={intent.set_live}
          onChange={() => handleInputChange("set_live", !intent.set_live)}
          className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 data-[checked]:bg-primary"
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
          />
        </Switch>
      </div>
    </div>
  );
};

export default CreateUpdateIntentModalBody;
